import { RootState } from 'data/store/store';

export const NAME = 'data/USER';
export const LOAD_USER_DATA = `${NAME}/LOAD`;
export const SET_USER_DATA = `${NAME}/SET`;

export type UserData = {
  name: string;
  country: string;
  avatar: string | null;
  smallProfileImageUrl: string | null;
  isNewUser: boolean;
};

export type UserDataState = {
  data: UserData | null;
  isLoading: boolean;
};

type SetUserDataAction = {
  type: typeof SET_USER_DATA;
  data: UserData | null;
};

export const setUserData = (data: UserData | null): SetUserDataAction => ({
  type: SET_USER_DATA,
  data,
});

type LoadUserDataAction = {
  type: typeof LOAD_USER_DATA;
};

export type UserDataAction = LoadUserDataAction | SetUserDataAction;

export const loadUserData = (): LoadUserDataAction => ({
  type: LOAD_USER_DATA,
});

export const initialState: UserDataState = {
  isLoading: true,
  data: null,
};

type UserActionTypes = SetUserDataAction | LoadUserDataAction;

export const reducer = (state = initialState, action: UserActionTypes) => {
  switch (action.type) {
    case LOAD_USER_DATA:
      return {
        ...state,
        isLoading: true,
      };

    case SET_USER_DATA:
      return {
        ...state,
        isLoading: false,
        data: (action as SetUserDataAction).data,
      };

    default:
      return state;
  }
};

export const selector = (state: RootState) => state[NAME];
